import React, { useState } from 'react';
import './styles.scss';
import { RiDeleteBin5Line } from "react-icons/ri";

const ImageModal = ({ src, alt, onDelete, isDeleteReq = true }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showDeleteIcon, setShowDeleteIcon] = useState(false);
    
    const handleImageClick = () => {
        setIsOpen(true);
    };
    
    const handleClose = () => {
        setIsOpen(false);
    };
    
    const handleDelete = (e) => {
        e.stopPropagation();
        if (onDelete) onDelete();
    };
    
    return (
        <div 
            className="thumbnail-container"
            onMouseEnter={() => isDeleteReq && setShowDeleteIcon(true)}
            onMouseLeave={() => isDeleteReq &&setShowDeleteIcon(false)}
        >
            <img src={src} alt={alt} onClick={handleImageClick} className="thumbnail" />
            {showDeleteIcon && (
                <div className="delete-icon" onClick={handleDelete}>
                    <RiDeleteBin5Line size={20} />
                </div>
            )}
            {isOpen && (
                <div className="modal-overlay" onClick={handleClose}>
                    <img src={src} alt={alt} className="modal-image" />
                </div>
            )}
        </div>
    );
};

export default ImageModal;